var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconExport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.094,
    height: 16.27,
    viewBox: "0 0 18.094 16.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m17.926 29.766.02-.027.023-.031.02-.033.017-.029.016-.034.015-.032.012-.033c.004-.011.009-.023.012-.035l.009-.034.009-.037c.003-.013 0-.026.006-.039s0-.022 0-.033v-.177c0-.011 0-.026-.006-.039s-.006-.025-.009-.037l-.009-.033-.012-.035-.012-.033c-.004-.011-.01-.021-.015-.032l-.016-.034-.018-.03a.345.345 0 0 0-.02-.032l-.023-.031-.02-.027q-.022-.027-.047-.052l-1.849-1.849a.74.74 0 1 0-1.046 1.046l.586.586h-2.257v-3.898a.736.736 0 0 0-.168-.468l-.043-.047-.006-.007-.019-.02-5.4-5.4a.958.958 0 0 0-.047-.043l-.016-.012-.036-.027-.019-.013-.04-.024-.016-.01-.055-.026-.023-.009-.037-.014-.026-.008-.043-.011h-.019l-.063-.01H.74a.74.74 0 0 0-.74.74V34.03a.74.74 0 0 0 .74.74h11.832a.74.74 0 0 0 .74-.74v-3.993h2.257l-.586.586a.74.74 0 1 0 1.046 1.046l1.849-1.849.048-.054zM7.888 21.025l2.9 2.9h-2.9zm3.944 12.266H1.479V19.979h4.93v4.684a.74.74 0 0 0 .74.74h4.684v3.155h-3.2a.74.74 0 1 0 0 1.479h3.2z",
    transform: "translate(0 -18.5)",
    style: {
      fill: "#fff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExport);
export default __webpack_public_path__ + "static/media/icon-export.789e905f.svg";
export { ForwardRef as ReactComponent };